import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Form as bForm, Container, Row, Col } from "react-bootstrap"
import { Divider, Form } from "semantic-ui-react";
import { useEffect } from "react";
import { useState } from "react";
import axios from "axios";

const ColorEdit = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const [idColor, setIdColor] = useState('')
    const [colorName, setColorName] = useState('')
    const [color1, setColor1] = useState('')
    const [color2, setColor2] = useState('')
    const [color3, setColor3] = useState('')

    const handleSubmit = () => {
        let param = {
            id_color : idColor,
            name: colorName,
            color_main : color1,
            color_secondary:color2,
            color_accent : color3,
        }

        axios.post("https://hoopsdevteam.com/api_web/controler/cms_rr.php/?index=28", param)
        .then(res => {
            console.log(res.data)
            if (res.data.state === 200){
                navigate('/color')
            }
        })
    }

    useEffect(() => {
        let data = location.state
        setIdColor(data.id_color)
        setColorName((data.name) ? data.name : '')
        setColor1(data.color_main)
        setColor2(data.color_secondary)
        setColor3(data.color_accent)
    }, [location.state])


    return (
        <Container fluid>
            <Row className="mt-1 mb-3">
                <div className="text-facebook h3 mb-0">Edit Product Color</div>
                <div className="text-muted">Edit color for product attribute color</div>
            </Row>
            <Divider />

            <Row className="d-flex justify-content-center mb-3 mt-3">
                <Col xl={6} lg={8} md={10} sm={12}>
                    <Form widths="equal" onSubmit={handleSubmit}>
                        <Form.Input
                            label="Color Name"
                            type="text"
                            className="mb-3"
                            value = {colorName}
                            onChange={(e) => setColorName(e.target.value)}
                            required
                        ></Form.Input>

                        <Form.Field>
                            <bForm.Label>Color Primary</bForm.Label>
                            <bForm.Control
                                type="color"
                                className="mb-3"
                                title="Select Color"
                                value={color1}
                                onChange={(e) => setColor1(e.target.value)}
                                required
                            />
                            <bForm.Label>Color Secondary</bForm.Label>
                            <bForm.Control
                                type="color"
                                className="mb-3"
                                title="Select Color"
                                value={color2}
                                onChange={(e) => setColor2(e.target.value)}
                                required
                            />
                            <bForm.Label>Color Accent</bForm.Label>
                            <bForm.Control
                                type="color"
                                className="mb-3"
                                title="Select Color"
                                value={color3}
                                onChange={(e) => setColor3(e.target.value)}
                                required
                            />
                        </Form.Field>
                        <Form.Button content="Update Color" color="facebook" className="mt-5" />
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}

export default ColorEdit